import React, { useCallback, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import EfisModalAtribuirProcesso from "../../../../components/UI/EfisModal/EfisModalAtribuirProcesso";
import SelectDiretor from "../../../../components/UI/SelectInput/SelectDiretor";
import { AuthContext } from "../../../../context/AuthContext";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

/**
 * ATRIBUIR PROCESSO PARA OUTRO DIRETOR EM ORDEM DE SERVIÇO
 */
const useAtribuirProcesso = ({ formik }) => {
  const { user } = useContext(AuthContext);
  const [showAtribuirProcessoConfirm, setShowAtribuirProcessoConfirm] = useState({
    show: false,
    body: null,
    context: null,
  });
  const { request, data, errors } = useApiClient();

  useEffect(() => {
    if (!data && !errors) return;

    if (data) {
      toast.success("Novo Diretor Atribuido ao processo com sucesso.");
      window.location.reload();
    }

    if (errors) {
      toast.error(errors.message);
    }
    setShowAtribuirProcessoConfirm({ show: false });
  }, [data, errors]);

  const atribuirProcesso = useCallback(
    (cdDiretor, numOs, cdDiretorAtribuido) => {
      if (cdDiretor === "") {
        toast.warning("Você deve selecionar um diretor.");
        return;
      }

      if (numOs === "") {
        toast.warning("Você deve informar uma OS.");
        return;
      }

      if (cdDiretor === cdDiretorAtribuido) {
        toast.warning("Você deve selecionar um diretor diferente do que já está atribuído.");
        return;
      }

      const values = {
        DiretorAtribuido: cdDiretor,
        OrdemServico: numOs,
      };
      request(apiRoutes.fiscalizacao.ordemservico.atribuirProcesso, values);
    },
    [request],
  );

  const atribuirProcessoModal = (
    <EfisModalAtribuirProcesso
      title="Atribuir Processo"
      primaryLabel="Atualizar"
      secondaryLabel="Cancelar"
      show={showAtribuirProcessoConfirm.show}
      body={showAtribuirProcessoConfirm.body}
      closeHandler={() => setShowAtribuirProcessoConfirm({ show: false })}
      confirmationHandler={() => {
        atribuirProcesso(
          document.getElementsByName("codigoDiretor")[0].value,
          showAtribuirProcessoConfirm.context.nuOs,
          showAtribuirProcessoConfirm.context.diretorAtribuido,
        );
      }}
    >
      <h5 style={{ marginBottom: 20 }}>
        {showAtribuirProcessoConfirm.context?.nomeDiretor ?? (
          <span style={{ color: "red" }}>Não existe diretor atribuido</span>
        )}
      </h5>
      <SelectDiretor
        formik={formik}
        field="codigoDiretor"
        titulo="Alterar para Diretor:"
        sqorgaologado={user.sequencialOrgao}
      />
    </EfisModalAtribuirProcesso>
  );

  return {
    atribuirProcessoModal,
    showAtribuirProcessoConfirm,
    setShowAtribuirProcessoConfirm,
  };
};

export default useAtribuirProcesso;
